import React from "react";
import { CardFront } from "./CardFront";
import { CardBack } from "./CardBack";
import { ClassicTheme } from "./themes/classic";
import { CardSVGProps } from "./types";

export const CardSVG: React.FC<CardSVGProps> = React.memo(({ 
  card, 
  faceDown = false, 
  scale = 1,
  onClick 
}) => {
  const theme = ClassicTheme;
  const { width, height } = theme.card;
  const scaledWidth = width * scale;
  const scaledHeight = height * scale;

  const handleClick = onClick ? () => onClick() : undefined;

  return (
    <svg
      width={scaledWidth}
      height={scaledHeight}
      viewBox={`0 0 ${width} ${height}`}
      onClick={handleClick}
      style={{
        cursor: onClick ? "pointer" : "default",
        userSelect: "none",
      }}
    >
      {faceDown || !card ? (
        <CardBack theme={theme} />
      ) : (
        <CardFront card={card} theme={theme} />
      )}
    </svg>
  );
});

CardSVG.displayName = "CardSVG";
